<template>
    <div class="inner-wrap">
        <!-- :style="{'height': height}" -->
        <div class="left">
            <h1>Pattern Selection</h1>
            <div class="btn-group">
                <div class="btn btn-already cursor" @click="open_pattern_modal" :class="{active: form_data.pattern_type===1}">
                    <span>Select existing platform patterns on the right</span>
                </div>
                <div class="btn btn-self cursor" :class="{active: form_data.pattern_type===2}" @click="handleUploadClick">
                    <span> Upload your own pattern files</span>
                </div>
                <div class="btn btn-self btn-making cursor" @click="use_custom_pattern" :class="{active: form_data.pattern_type===3}">
                    <span>Select pattern customization service  $ {{making_price|price_format}}</span>
                </div>
            </div>
            <h1>Selected Patterns</h1>
            <div class="file-list">
                <div v-for="(v, k) in form_data.pattern" :key="`pa` + k" class="file-item" >
                    <template v-if="form_data.pattern_type===1">
                        <span class="flag">Platform Pattern</span>
                        <img :src="v.image|default_img" alt="" class="pa-img">
                        <div class="r1">
                            <p class="pa-name cursor" @click.prevent="open_window(v.path)">{{ v.name }}</p>
                            <p class="pa-mc">Fabric consumption (meters):</p>
                            <input :value="form_data.consumption" @input="input1($event, 'consumption')" :disabled="form_data.pattern_id > 0" class="input" placeholder="Please enter consumption" type="number"/>
                            <p class="pa-ac">Lining consumption (meters): </p>
                            <input :value="form_data.consumption2" @input="input1($event, 'consumption2')" :disabled="form_data.pattern_id > 0" class="input" placeholder="Please enter consumption" type="number"/>
                        </div>
                        <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="cancel_pattern()" />
                    </template>
                    <template v-else-if="form_data.pattern_type===2">
                        <span class="flag">Customer-provided Pattern</span>
                        <div class="padding"></div>
                        <p class="label">Sex：</p>
                        <div class="tag-list">
                            <div class="tag-item cursor" @click="fill_custom_pattern('sex', vv)" v-for="(vv,kk) in ['男', '女','不限','儿童']" :key="`pc`+kk" :class="{active:vv===v.sex}">
                                <img v-if="vv===v.sex" src="@/assets/images/design/icon-check-yes.png" alt="" class="check">
                                <img v-else src="@/assets/images/design/icon-check-no.png" alt="" class="check">
                                <span>{{vv|sex_filter2}}</span>
                            </div>
                        </div>
                        <a class="doc-wrap" target="_blank" :href="v.path">
                            <img :src="util.get_image_icon(v.path)" class="icon-doc" />
                            <span>{{v.name}}</span>
                        </a>
                        <div class="upload-wrap">
                            <Upload
                                    :action="upload_url"
                                    :data="{ dir: 'template' }"
                                    :before-upload="(file)=>onBeforeUpload(file, 'path')"
                                    :show-upload-list="false"
                            >
                                <div class="btn-upload cursor">
                                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                                    <span>Upload pattern file</span>
                                </div>
                            </Upload>
                        </div>

                        <div class="r2">
                            <p class="pa-mc">Fabric consumption (meters):<span class="red">*</span>:</p>
                            <input :value="form_data.consumption" @input="input1($event, 'consumption')" :disabled="form_data.pattern_id > 0" class="input" :class="{noborder: form_data.pattern_type===1}" placeholder="Please enter consumption" type="number"/>
                            <p class="pa-ac">Lining consumption (meters):</p>
                            <input :value="form_data.consumption2" @input="input1($event, 'consumption2')" :disabled="form_data.pattern_id > 0" class="input" :class="{noborder: form_data.pattern_type===1}" placeholder="Please enter consumption" type="number"/>
                        </div>
                        <div class="upload-wrap" >
                            <template v-if="!!v.guige_path">
                                <div class="file">
                                    <img :src="util.get_image_icon(v.guige_path)" class="icon-doc" />
                                    <span class="cursor" @click.stop="open_window(v.guige_path)">{{v.guige_name}}</span>
                                    <img class="icon-del cursor" src="@/assets/images/design/icon-del.png" @click.prevent="del_guige_file" alt="">
                                </div>
                            </template>
                            <Upload
                                    :action="upload_url"
                                    :data="{ dir: 'template' }"
                                    :before-upload="(file)=>onBeforeUpload(file, 'guige')"
                                    :show-upload-list="false"
                            >
                                <div class="btn-upload cursor">
                                    <img class="icon" src="@/assets/images/design/icon-upload-black.png" alt="">
                                    <span>Upload specification sheet</span>
                                </div>
                            </Upload>
                        </div>
                        <img src="@/assets/images/design/icon-del.png" class="icon-del cursor" @click.prevent="cancel_pattern()" />
                    </template>
                    <template v-else-if="form_data.pattern_type===3">
                        <span class="flag">Custom Pattern</span>
                        <div class="padding"></div>
                        <p class="label">Sex：</p>
                        <div class="tag-list">
                            <div class="tag-item cursor" @click="fill_custom_pattern('sex', vv)" v-for="(vv,kk) in ['男', '女','不限','儿童']" :key="`pc`+kk" :class="{active:vv===v.sex}">
                                <img v-if="vv===v.sex" src="@/assets/images/design/icon-check-yes.png" alt="" class="check">
                                <img v-else src="@/assets/images/design/icon-check-no.png" alt="" class="check">
                                <span>{{vv|sex_filter2}}</span>
                            </div>
                        </div>
                        <p class="label">Usage scenario:</p>
                        <div class="tag-list">
                            <div class="tag-item cursor" @click="fill_custom_pattern('c_scene', vv)" v-for="(vv,kk) in custom_scene" :key="`pc`+kk" :class="{active:vv===v.c_scene}">
                                <img v-if="vv===v.c_scene" src="@/assets/images/design/icon-check-yes.png" alt="" class="check">
                                <img v-else src="@/assets/images/design/icon-check-no.png" alt="" class="check">
                                <span>{{vv}}</span>
                            </div>
                        </div>
                        <p class="label">Pattern type:</p>
                        <div class="tag-list">
                            <div class="tag-item cursor" @click="fill_custom_pattern('c_type', vv)" v-for="(vv,kk) in custom_type" :key="`pc`+kk" :class="{active:vv===v.c_type}">
                                <img v-if="vv===v.c_type" src="@/assets/images/design/icon-check-yes.png" alt="" class="check">
                                <img v-else src="@/assets/images/design/icon-check-no.png" alt="" class="check">
                                <span>{{vv}}</span>
                            </div>
                        </div>
                        <p class="label">Pattern description:</p>
                        <textarea name="" id="" cols="30" rows="10" @input="fill_custom_pattern2($event)" :value="v.c_content"></textarea>
                    </template>

                </div>
            </div>

        </div>
        <!-- :style="{width: width}" -->
        <div class="right"  >
            <template v-if="is_lesson_show">
                <Lesson ></Lesson>
            </template>
            <template v-else>
                <div class="pattern-wrap" :style="{'min-height': height}">
                    <div class="top">
                        <h2>Pattern Selection</h2>
                        <div class="input-wrap">
                            <input v-model="form_data_pattern.keyword" placeholder="Enter keywords to search patterns" type="text" @keyup.enter="search_pattern"/>
                            <img alt="" class="icon-search" src="@/assets/images/icon-search.png" @click="search_pattern"/>
                        </div>
                    </div>
                    <div class="content">
                        <div class="category-list">
                            <div v-for="(v, k) in pattern_category_list" :key="`pc` + k" :class="{active: current_pattern_category_id === v.pattern_category_id,}" class="category-item cursor" @click="choose_pattern_category(v)">
                                {{ v.category_name_en }}
                            </div>
                        </div>
                        <div class="right">
                            <div class="label-list">
                                <div class="label-item">
                                    <p>Gender:</p>
                                </div>
                                <div :class="{ active: form_data_pattern.sex===0 }" class="label-item" @click="choose_pattern_sex(0)">
                                    <p>Unrestricted</p>
                                </div>
                                <div :class="{ active: form_data_pattern.sex===1 }" class="label-item" @click="choose_pattern_sex(1)">
                                    <p>Male</p>
                                </div>
                                <div :class="{ active: form_data_pattern.sex===2 }" class="label-item" @click="choose_pattern_sex(2)">
                                    <p>Female</p>
                                </div>
                            </div>
                            <div v-for="(v, k) in pattern_label_list" :key="`lf1` + k" class="label-list">
                                <div class="label-item">
                                    <p>{{ v.label_name_en }}：</p>
                                </div>
                                <div
                                        v-for="(vv, kk) in v.content_en"
                                        :key="`lf2` + kk"
                                        :class="{ active: pattern_label_ids.includes(vv.id) }"
                                        class="label-item"
                                        @click="choose_label(vv)"
                                >
                                    <p>{{ vv.name }}</p>
                                </div>
                            </div>
                            <template v-if="pattern_list.length > 0">
                                <div class="fabric-list">
                                        <div v-for="(v, k) in pattern_list" :key="`df` + k" :class="{ active: form_data.pattern_id === v.id }" class="fabric-item" @click="open_pattern_detail(v)">
                                            <img :src="v.main_image|default_img" alt="" />
                                            <p>{{ v.pattern_number }}</p>
                                            <img v-show="form_data.pattern_id === v.id" alt="" class="icon-check" src="@/assets/images/icon-check.png"/>
                                            <div class="mask">
                                                <div class="btn">
                                                    <span class="fa-detail" @click.stop="open_pattern_detail(v)">View</span>
                                                    <span class="fa-choose" @click.stop="cancel_pattern()" v-if="form_data.pattern_id === v.id">Cancel</span>
                                                    <span class="fa-choose" @click.stop="confirm_pattern(v)" v-else>Select</span>
                                                </div>
                                            </div>
                                        </div>
                                </div>
                                <Page :current="form_data_pattern.page" v-if="total>0" :page-size="form_data_pattern.size"  :total="total" @on-change="changePage" show-total style="margin-top: 20px;"  ></Page>
                            </template>
                            <template v-else>
                                <img class="no-data" :src="require(`@/assets/images/no-data.png`)"  alt="">
                            </template>
                        </div>
                    </div>
                </div>
            </template>
        </div>

        <popup :show.sync="is_popup_show_detail" height="680px" width="980px">
            <div class="fabric-content-wrap">
                <div class="info-wrap">
                    <div class="left-popup">
                        <div v-if="current_pattern.image_list.length > 0" class="slider">
                            <swiper ref="swiper" :options="swiperOption">
                                <swiper-slide
                                        v-for="(item, index) in current_pattern.image_list"
                                        :key="`sl` + index"
                                >
                                    <img v-viewer :src="item.url" class="f-img" />
                                </swiper-slide>
                                <div slot="button-prev" class="swiper-button-prev"></div>
                                <div slot="button-next" class="swiper-button-next"></div>
                            </swiper>
                        </div>
                    </div>
                    <div class="right">
                        <p class="name">{{ current_pattern.pattern_number }}</p>
                        <!-- category_name -->
                         <p class="no">Category:<span>{{ current_pattern.category_name_en }}</span></p>
                        <p class="no">Gender:<span>{{ current_pattern.sex | sex_filter }}</span></p>
                        <p class="no">Fabric consumption (meters):<span>{{ current_pattern.consumption  }}</span></p>
                        <p class="no" v-show="current_pattern.consumption2>0">Lining consumption (meters):<span>{{ current_pattern.consumption2  }}</span></p>
                    </div>
                </div>
                <div class="title-box">
                    <div class="title">Specification size details</div>
                    <div class="line"></div>
                </div>
                 <div class="richtext-wrap">
                    <div class="size-list">
                        Size:<span v-for="(item,index) in current_pattern.size_list" :key="index">{{ item }}</span>
                    </div>
                    <table border="none">
                        <thead>
                            <tr style="background:#e5e5e5;text-align:center;">
                                <th style="background:transparent !important">Size/Part</th>
                                <th v-for="part in current_pattern.part_list" :key="part">{{ getPatternName(part) }}</th>
                            </tr>
                        </thead>
                        <tbody border="none">
                            <tr v-for="row in table_data" :key="row.size" style="text-align:center;">
                                <td style="width:auto;min-width:100px;max-width:150px;">{{ row.size }}</td>
                                <td border="none" v-for="part in current_pattern.part_list" :key="`${row.size}-${part}`" style="width:100px;">
                                    <div>{{ row[part] && row[part].normal ? row[part].normal : '-' }}</div>
                                  </td>
                            </tr>
                        </tbody>
                    </table>
                 </div>
            </div>
            <div class="btn-box">
                    <button class="cancel-btn" @click="is_popup_show_detail=false">Cancel</button>
                    <button class="confirm-btn" @click="toggle_pattern(current_pattern)">Confirm Selection</button>
                </div>
        </popup>
    </div>
</template>

<script>
    import {
    PatternCategoryList,
    PatternLabelList,
    PatternList,
    PatternSetting,
} from "@/api/index.js";
import Popup from "@/components/Popup.vue";
import { uploadFileToOSS } from "@/utils/oss";
import util from '@/utils/util';
import axios from "axios";
import "swiper/dist/css/swiper.css";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import { mapState } from 'vuex';
import Lesson from "./Lesson.vue";

    export default {
        name: "Pat",
        data() {
            return {
                swiperOption: {
                    loop: false, // 循环播放, 可有无限滚动效果，初始加载即是滚动后的效果
                    autoplay: {
                        delay: 2000,
                        disableOnInteraction: false,
                    },
                    navigation: {
                        nextEl: ".swiper-button-next",
                        prevEl: ".swiper-button-prev",
                    },
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true,
                    },
                    observer: true, //修改swiper自己或子元素时，自动初始化swiper
                    observeParents: true, //修改swiper的父元素时，自动初始化swiper
                },
                util: util,
                upload_url: process.uniEnv.BASE_API + "/util/upload-image",
                sub_product_category_list: [],
                is_popup_show_detail: false,
                form_data_pattern: {
                    page: 1,
                    size: 15,
                    keyword: "",
                    sex: 0,
                    pattern_category_id: 0,
                },
                pattern_category_list: [],
                pattern_list: [],
                total: -1,
                pattern_label_list: [],
                pattern_label_ids: [],
                current_pattern_category_id: 0,
                current_pattern: {
                    image_list: []
                },
                width: '600px',
                making_price: 0,
                custom_scene: [],
                custom_type: [],
                table_data:[],
                is_show_confirm:false,
            }
        },
        components: {
            Popup,
            swiper,
            swiperSlide,
            Lesson
        },
        watch: {
            "form_data.parent_product_category_id": {
                handler(newVal, oldVal) {
                    console.log('base', newVal, oldVal)
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === newVal);
                        this.sub_product_category_list = obj ? obj.children : [];
                        this.making_price = obj ? obj.making_price_en : 0;
                        this.form_data_pattern.page = 1
                        this.getPatternList()
                    }
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
            "form_data.child_product_category_id": {
                handler(newVal, oldVal) {
                    if (newVal > 0) {
                        let obj = this.product_category_list.find((v) => v.product_category_id === this.form_data.parent_product_category_id);
                        let children = obj?.children;
                        if (children) {
                            let child = this.sub_product_category_list.find((v) => v.product_category_id === newVal);
                            this.making_price = child ? (child.making_price_en > 0 ? child.making_price_en : obj.making_price_en) : 0;
                        }
                        this.form_data_pattern.page = 1
                    }
                    this.getPatternList()
                },
                immediate: true, // 立即执行一次handler以初始化数据
                deep: true, // 深度监听（虽然在这个场景下可能不是必需的）
            },
        },
        computed: {
            ...mapState({
                form_data: (state) => state.design.form_data,
                height: (state) => state.design.height,
                is_lesson_show: (state) => state.design.is_lesson_show,
                product_category_list: (state) => state.design.product_category_list,
            }),
        },
        methods: {

            handleUploadClick() {
                //>前置判断逻辑处理
                if (this.form_data.pattern_type != 2 && this.hasPatternValue(this.form_data.pattern)) {
                    //>如果当前不是上传文件模式且已有pattern值，则弹出确认框
                    this.$DModal.confirm({
                        content: 'Do you want to replace the selected pattern?',
                        okText:'Confirm',
                        cancelText:'Cancel',
                        onOK: async () => {
                            //>直接触发上传
                            this.triggerUpload();
                        }
                    })
                }else if(!this.form_data.pattern_id && !this.hasPatternValue(this.form_data.pattern)){
                    this.triggerUpload();
                }
            },

            triggerUpload() {
                //>创建一个临时的 input 元素来触发文件选择
                const input = document.createElement('input');
                input.type = 'file';
                input.style.display = 'none';

                //>添加事件监听器
                input.onchange = (e) => {
                    const file = e.target.files[0];
                    if (file) {
                        //>调用 beforeUpload 处理文件
                        this.reset_pattern()
                        this.choose_pattern_type(2)
                        let object = { name: '', path: '', guige_name:'', guige_path: '' }
                        this.$store.commit('design/update_common', {key: 'pattern', value: []})
                        this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
                        this.onBeforeUpload(file, 'path');
                    }
                    //>清理临时元素
                    document.body.removeChild(input);
                };

                //>将 input 添加到页面并触发点击
                document.body.appendChild(input);
                input.click();
            },
            hasPatternValue(pattern) {
                if(!pattern) return false;
                return Object.values(pattern).some(value =>
                    value !== '' && value !== null && value !== undefined
                );
            },

            choose_label(v) {
                if (this.pattern_label_ids.includes(v.id)) {
                    this.pattern_label_ids = this.pattern_label_ids.filter((item) => {
                        return item !== v.id;
                    });
                } else {
                    this.pattern_label_ids.push(v.id);
                    this.pattern_label_ids = [...new Set(this.pattern_label_ids)];
                }
                this.form_data_pattern.page = 1
                this.getPatternList();
            },
            getPatternName(field_key){
                const {field_list} = this.current_pattern;
                const data = field_list.filter((item)=>item.field_key === field_key);
                console.log('data====>',data);
                return data[0].field_name_en;
            },
            generateTableData(partList, sizeList, sizeInfo) {
                const result = [];

                // 添加校验：确保 sizeList 是一个非空数组
                if (!Array.isArray(sizeList) || sizeList.length === 0) {
                    return result; // 返回空数组，避免报错
                }

                for (const sizeKey of sizeList) {
                    let size = '';

                    // 处理不同类型的 sizeKey
                    if (typeof sizeKey === 'string') {
                        // 如果是字符串，例如 "XL"
                        size = sizeKey;
                    } else if (typeof sizeKey === 'number') {
                        // 如果是数字，例如 35, 36
                        size = String(sizeKey); // 转换为字符串
                    } else if (Array.isArray(sizeKey)) {
                        // 如果是数组，例如 ["XL"]
                        size = String(sizeKey[0]);
                    } else if (typeof sizeKey === 'object' && sizeKey !== null) {
                        // 如果是对象，例如 { key: "XL" }
                        const keys = Object.keys(sizeKey);
                        if (keys.length > 0) {
                            size = String(keys[0]); // 使用第一个键作为 size 名称
                        }
                    } else {
                        console.warn('Unexpected sizeKey type:', typeof sizeKey, sizeKey);
                        continue;
                    }

                    const sizeData = sizeInfo[size];

                    const row = {
                        size: size,
                    };

                    for (const part of partList) {
                        if (sizeData && sizeData[part]) {
                            row[part] = {
                                normal: sizeData[part].normal,
                                min: sizeData[part].min,
                                max: sizeData[part].max,
                            };
                        } else {
                            row[part] = {
                                normal: "",
                                min: "",
                                max: "",
                            };
                        }
                    }

                    result.push(row);
                }

                return result;
            },
            fill_custom_pattern(field, content) {
                let object = this.form_data.pattern[0]
                object[field] = content
                this.$store.commit('design/update_common', {key: 'pattern', value: []})
                this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
            },
            fill_custom_pattern2(e) {
                let object = this.form_data.pattern[0]
                object.c_content = e.target.value
                this.$store.commit('design/update_common', {key: 'pattern', value: []})
                this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})

            },
            open_window(path) {
                window.open(path, "_blank");
            },
            choose_pattern_type(type) {
                this.$store.commit('design/update_common', {key: 'pattern_type', value: type})
            },
            changePage(page) {
                this.form_data_pattern.page = page
                this.getPatternList()
            },
            input1($event, field) {
                this.$store.commit('design/update_common', {key: field, value: $event.target.value})
            },
            search_pattern() {
                this.getPatternList();
            },
            open_pattern_detail(pattern) {
                console.log('pattern',pattern);
                this.current_pattern = pattern;
                this.table_data = this.generateTableData(pattern.part_list,pattern.size_list,pattern.size_info);
                console.log(this.table_data,'<===tableData');
                this.is_popup_show_detail = true;
            },
            toggle_pattern(pattern) {
                if(this.form_data.pattern_id === pattern.id) {
                    this.cancel_pattern()
                } else {
                    this.confirm_pattern(pattern)
                }
                if(this.is_popup_show_detail){
                    this.is_popup_show_detail = false
                }
            },
            confirm_pattern(pattern) {
                if(this.form_data.pattern_id > 0 || this.hasPatternValue(this.form_data.pattern)) {
                    // 切换版型
                    this.$DModal.confirm({
                        content: 'Do you want to replace the selected pattern?',
                        okText:'Confirm',
                        cancelText:'Cancel',
                        onOK: async () => {
                            this.push_pattern(pattern)
                        }
                    })
                } else {
                  this.push_pattern(pattern)
                }
            },
            push_pattern(pattern) {
                this.reset_pattern()
                this.choose_pattern_type(1)
                this.$store.commit('design/update_common', {key: 'pattern_id', value: pattern.id})
                this.$store.commit('design/update_common', {key: 'consumption', value: pattern.consumption})
                this.$store.commit('design/update_common', {key: 'consumption2', value: pattern.consumption2})
                let object = {image: pattern.main_image, name: pattern.pattern_number, path: '', guige_name: '', guige_path: ''}
                this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
            },
            cancel_pattern() {
                this.$DModal.confirm({
                    content: 'Do you want to cancel the selected pattern?',
                    okText:'Confirm',
                    cancelText:'Cancel',
                    onOK: async () => {
                        this.reset_pattern()
                    }
                })
            },
            reset_pattern() {
                this.$store.commit('design/update_common', {key: 'pattern_type', value: 0})
                this.$store.commit('design/update_common', {key: 'pattern_id', value: 0})
                this.$store.commit('design/update_common', {key: 'consumption', value: 0})
                this.$store.commit('design/update_common', {key: 'consumption2', value: 0})
                this.$store.commit('design/update_common', {key: 'pattern', value: []})
            },
            use_custom_pattern() {
                if(this.form_data.pattern_type != 3 && this.hasPatternValue(this.form_data.pattern)){
                    this.$DModal.confirm({
                        content: 'Do you want to replace the selected pattern?',
                        okText:'Confirm',
                        cancelText:'Cancel',
                        onOK: async () => {
                            this.reset_pattern()
                            this.choose_pattern_type(3)
                            let object = {image: '', name: '', path: "", guige_name: '', guige_path: '', c_scene: '', c_type: ''}
                            this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
                        }
                    })
                }else if(!this.form_data.pattern_id && !this.hasPatternValue(this.form_data.pattern)){
                    this.reset_pattern()
                    this.choose_pattern_type(3)
                    let object = {image: '', name: '', path: "", guige_name: '', guige_path: '', c_scene: '', c_type: ''}
                    this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
                }
            },
            choose_pattern_category(category) {
                this.current_pattern_category_id = this.form_data_pattern.pattern_category_id = category.pattern_category_id;
                this.getPatternList();
            },
            choose_pattern_sex(sex) {
                this.form_data_pattern.sex = sex
                this.getPatternList()
            },
            open_pattern_modal() {
                this.$store.commit('design/hide_lesson')
                this.getPatternList().then(() => {
                });
            },
            del_guige_file() {
                let object = this.form_data.pattern[0]
                object.guige_name = ""
                object.guige_path = ""
                this.$store.commit('design/update_common', {key: 'pattern', value: []})
                this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})

            },
            async getPatternCategoryList() {
                return PatternCategoryList().then((response) => {
                    this.pattern_category_list = [
                        { category_name_en: "All", pattern_category_id: 0 },
                        ...response.data,
                    ];
                    console.error(this.pattern_category_list,"123")
                    return response;
                });
            },
            async getPatternLabelList() {
                return PatternLabelList().then((response) => {
                    this.pattern_label_list = [...response.data];
                    return response;
                });
            },
            async getPatternList() {
                return PatternList({
                    ...this.form_data_pattern,
                    label_id: this.pattern_label_ids,
                    first_product_category_id: this.form_data.parent_product_category_id,
                    second_product_category_id: this.form_data.child_product_category_id,
                }).then((response) => {
                    this.pattern_list = response.data.list;
                    this.total = response.data.total;
                    return response;
                });
            },
            onBeforeUpload(file, field) {
                uploadFileToOSS(file, 'template').then(url => {
                    if(field === 'path') {
                        let object = this.form_data.pattern[0]
                        object.name = file.name
                        object.path = url
                        this.$store.commit('design/update_common', {key: 'pattern', value: []})
                        this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
                    } else if(field === 'guige') {
                        let object = this.form_data.pattern[0]
                        object.guige_name = file.name
                        object.guige_path = url
                        this.$store.commit('design/update_common', {key: 'pattern', value: []})
                        this.$store.commit('design/arr_push_one', {key: 'pattern', value: object})
                    }
                })
                return false;
            },
        },
        mounted() {
            this.width = window.innerWidth - 220 - 490 - 30 + 'px'
            PatternSetting().then((response) => {
                console.log('res',response);
                this.custom_scene = response.data.c_scene_en;
                this.custom_type = response.data.c_type_en;
                console.log('scene',this.custom_scene);
                console.log('type',this.custom_type);
            })
            axios.all([
                this.getPatternCategoryList(),
                this.getPatternLabelList(),
            ]).then(
                axios.spread(() => {
                    return this.getPatternList()
                })
            )
        }
    }
</script>

<style scoped lang="scss">
    .inner-wrap {
        display: flex;
        flex-wrap: nowrap;
        height:100%;
        .left {
            padding: 0 30px 100px 30px;
            width: 490px;
            height:100%;
            background: white;
            overflow: auto;
            display: flex;
            flex-wrap: wrap;
            align-content: flex-start;
            h1 {
                width: 100%;
                height: 20px;
                line-height: 20px;
                font-size: 18px;
                color: #000000;
                border-left: 2px solid black;
                padding-left: 10px;
                margin: 20px 0;
            }
            .btn-group {
                display: flex;
                flex-wrap: wrap;
                align-items: center;
                width:100%;
                .btn {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    // width: 426px;
                    width:100%;
                    height: 50px;
                    border-radius: 5px 5px 5px 5px;
                    font-size: 12px;
                    margin: 8px 0;
                    cursor: pointer;
                    background: white;
                    color: black;
                    border: 1px solid #B3B3B3;

                    &.active, &:hover {
                        border: 1px solid #fa3d5a;
                        color: #fa3d5a;
                    }
                    &.btn-already {
                        img {
                            width: 17px;
                            height: 19px;
                            margin-right: 10px;
                        }
                    }
                    &.btn-self {
                        width:100%;
                        img {
                            width: 24px;
                            height: 24px;
                            margin-right: 10px;
                        }
                        .check {
                            width: 15px;
                            height: 15px;
                        }
                    }


                }
            }


            .file-list {
                display: flex;
                flex-wrap: wrap;

                .file-item {
                    position: relative;
                    width: 420px;
                    margin: 5px;
                    padding: 10px;
                    background: #FAFAFA;
                    display: flex;
                    flex-wrap: wrap;
                    align-items: center;
                    .flag {
                        position: absolute;
                        top: 0;
                        left: 0;
                        color: white;
                        text-align: center;
                        // width: 80px;
                        // height: 25px;
                        // line-height: 25px;
                        padding: 2px 10px;
                        background: #000000;
                        border-radius: 5px 0px 5px 0px;
                    }
                    // 平台版型相关CSS
                    .pa-img {
                        width: 180px;
                        height: 180px;
                        object-fit: contain;
                    }
                    .r1 {
                        display: flex;
                        flex-wrap: wrap;
                        width: 200px;
                        margin-left: 10px;
                        .pa-name {
                            width: 200px;
                            color: #1D1D1D;
                            margin: 10px 0;
                            font-weight: bold;
                        }
                        .pa-mc {
                            width: 200px;
                            color: #4D4D4D;
                        }
                        .pa-ac {
                            width: 200px;
                            color: #4D4D4D;
                        }
                        .input {
                            width: 200px;
                            height: 40px;
                            line-height: 40px;
                            border-radius: 5px;
                            padding: 0 10px;
                            border: none;
                            background: #FAFAFA;
                        }
                    }

                    // 客供版型相关CSS
                    .doc-wrap {
                        width: 100%;
                        height: 52px;
                        margin-top: 40px;
                        margin-bottom: 10px;
                        display: flex;
                        flex-wrap: nowrap;
                        align-items: center;
                        background: white;
                        .icon-doc {
                            width: 24px;
                            height: 24px;
                            margin:0 10px;
                        }
                    }
                    .r2 {
                        display: flex;
                        flex-wrap: wrap;
                        padding-bottom: 10px;
                        p {
                            margin: 8px 0;
                            width: 100%;
                            .red {
                                color: #FA3D5A;
                            }
                        }
                        .input {
                            width: 100%;
                            height: 40px;
                            line-height: 40px;
                            background: white;
                            border-radius: 5px;
                            padding: 0 10px;
                            border: none;
                        }
                    }
                    .upload-wrap {
                        position: relative;
                        width: 420px;
                        height: 50px;
                        background: white;
                        display: flex;
                        flex-wrap: wrap;
                        align-items: center;
                        .file {
                            position: relative;
                            width: 400px;
                            height: 42px;
                            line-height: 42px;
                            margin: 10px 5px;
                            background: #f3f3f3;
                            color: #1a1a1a;
                            font-size: 12px;
                            padding-left: 55px;
                            .icon-doc  {
                                position: absolute;
                                top: 5px;
                                left: 15px;
                                width: 32px;
                                height: 32px;
                            }
                            .icon-del {
                                position: absolute;
                                top: 12px;
                                right: 15px;
                                width: 20px;
                                height: 20px;
                                z-index: 10;
                            }
                        }
                        .btn-upload {
                            display: flex;
                            justify-content: center;
                            align-items: center;
                            width: 400px;
                            height: 45px;
                            background: #FFFFFF;
                            border: 1px solid #B3B3B3;
                            border-radius: 5px;
                            color: #1D1D1D;
                            font-size: 14px;
                            text-align: center;
                            margin: 10px 0;
                            .icon {
                                width: 24px;
                                height: 24px;
                            }
                        }
                    }

                    // 定制版型相关CSS
                    .padding {
                        width: 100%;
                        padding: 10px 0;
                    }
                    .label {
                        width: 100%;
                        margin: 10px 0;
                    }
                    .tag-list {
                        width:100%;
                        display: flex;
                        flex-wrap: wrap;
                        .tag-item {
                            width: 90px;
                            height: 35px;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                            border: 1px solid #E2E3E5;
                            border-radius: 4px;
                            margin:0 10px 10px 0;
                            font-size: 14px;
                            color: #4d4d4d;
                            .check {
                                width: 15px;
                                height: 15px;
                                margin-right: 10px;
                            }
                            &.active {
                                border: 1px solid #FA3D5A;
                            }
                        }
                    }
                    textarea {
                        padding: 10px;
                        width: 390px;
                        height: 150px;
                        border: none;
                    }
                    .icon-del {
                        position: absolute;
                        top: 6px;
                        right: 6px;
                        width: 18px;
                        height: 18px;
                    }
                }
            }
        }

        .right {
            // margin: 0 auto;
            display:flex;
            // align-items:center;
            justify-content:center;
            flex:1;
            width:100%;
            .pattern-wrap {
                margin-top: 10px;
                margin-right: 50px;
                padding: 10px;
                background: white;
                flex:1;
               .top {
                    display: flex;
                    justify-content: space-between;
                   padding-bottom: 5px;
                   border-bottom: 2px solid #f6f7fa;
                    h2 {
                        font-size: 20px;
                        color: #1a1a1a;
                        white-space: nowrap;
                    }

                    .input-wrap {
                        margin-left: 50px;
                        width: 280px;
                        height: 35px;
                        position: relative;

                        &:focus {
                            border: none !important;
                        }

                        &::after {
                            border: none !important;
                        }

                        input {
                            width: 100%;
                            height: 100%;
                            background: #f2f2f2;
                            border-radius: 17px;
                            padding: 0 45px 0 20px;
                            border: none !important;

                            &:focus {
                                border: none !important;
                            }

                            &::after {
                                border: none !important;
                            }
                        }

                        .icon-search {
                            position: absolute;
                            right: 18px;
                            top: 50%;
                            transform: translateY(-50%);
                            width: 20px;
                            height: 20px;
                            cursor: pointer;
                        }
                    }
               }

                /* 主内容区 */
                .content {
                    display: flex;

                    /* 左侧分类 */
                    .category-list {
                        width: 100px;
                        display: flex;
                        flex-wrap: wrap;
                        justify-content: center;
                        align-content: flex-start;
                        border-right: 1px solid #f6f7fa;
                        overflow-y: auto;
                        padding: 15px 0;
                        max-height:530px;

                        .category-item {
                            width: 80px;
                            height: 35px;
                            line-height: 35px;
                            text-align: center;
                            white-space: nowrap;
                            overflow: hidden;
                            text-overflow: ellipsis;
                            color: #1C1C1C;
                            border-radius: 5px;
                            &.active {
                                background: #1C1C1C;
                                color: white;
                                font-weight: 500;
                            }
                        }
                    }

                    /* 右侧内容 */
                    .right {
                        $left_width: 140px;
                        width: calc(100% - #{$left_width});
                        flex: 1;
                        display: flex;
                        flex-direction: column;
                        flex-shrink: 0;
                        padding: 20px;
                        overflow: hidden;

                        /* 标签筛选区 */
                        .label-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 12px 0;
                            margin-bottom: 5px;
                            width:100%;
                            .label-item {
                                padding: 0 15px;
                                height: 20px;
                                line-height: 20px;
                                border-radius: 15px;
                                //   background: #f6f6f6;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #ffecee;
                                    color: #fa3d5a;
                                    font-weight: 500;
                                }
                            }
                        }

                        /* 子分类 */
                        .sub-list {
                            display: flex;
                            flex-wrap: wrap;
                            gap: 10px;
                            margin-top: 10px;
                            margin-bottom: 10px;
                            background: #f6f6f6;
                            width:100%;

                            .sub-item {
                                padding: 0 12px;
                                height: 28px;
                                line-height: 28px;
                                border-radius: 14px;
                                cursor: pointer;
                                transition: all 0.2s;

                                &.active {
                                    background: #fa3d5a;
                                    color: white;
                                }
                            }
                        }

                        .no-data {
                            width:300px;
                            height: auto;
                            display: block;
                            margin:0 auto;
                        }
                        /* 面料列表 */
                        .fabric-list {
                            flex: 1;
                            display: grid;
                            grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
                            border-radius: 5px;
                            // gap: 6px 10px;
                            column-gap:55px;
                            row-gap:6px;
                            align-items: start;
                            overflow-y: auto;
                            padding: 15px;
                            background: #F6F7FA;
                            width:100%;
                            max-height:550px;

                            &::-webkit-scrollbar {
                                display: none !important;
                            }

                            .fabric-item {
                                position: relative;
                                // width: 142px;
                                flex:0 0 20%;
                                height: 175px;
                                margin: 0 5px 15px 5px;
                                cursor: pointer;
                                box-sizing: border-box;
                                border: 1px solid #e3e4e6;
                                border-radius: 5px;

                                img {
                                    // width: 140px;
                                    width:100%;
                                    height: 141px;
                                    border-top-left-radius: 5px;
                                    border-top-right-radius: 5px;
                                    object-fit: contain;
                                }

                                p {
                                    // width: 140px;
                                    width: 100%;
                                    height: 30px;
                                    line-height: 30px;
                                    white-space: nowrap;
                                    text-overflow: ellipsis;
                                    overflow: hidden;
                                    background: white;
                                    padding: 0 5px;
                                    border-top: 0.5px solid #e3e4e6;
                                    margin-top: -5px;
                                    text-align: center;
                                    border-bottom-left-radius: 5px;
                                    border-bottom-right-radius: 5px;
                                }

                                .icon-check {
                                    position: absolute;
                                    top: 0;
                                    right: 0;
                                    width: 25px;
                                    height: 25px;
                                }

                                &.active {
                                    border: 1px solid #fa3d5a;
                                }

                                .mask {
                                    display: none;
                                }

                                &:hover {
                                    .mask {
                                        display: block;
                                        position: absolute;
                                        top: 0;
                                        left: 0;
                                        right: 0;
                                        height: 140px;
                                        z-index: 100;
                                        background: rgba(0, 0, 0, 0.35);

                                        .btn{
                                            display:flex;
                                            justify-content:end;
                                            align-items:center;
                                            position:absolute;
                                            column-gap:10px;
                                            // top:115px;
                                            // right:10px;
                                            width:100%;
                                            justify-content:space-between;
                                            bottom:0;
                                            padding:0 10px;
                                            .fa-detail {
                                            // position: absolute;
                                            // right: 45px;
                                            // top: 115px;
                                            z-index: 101;
                                            color: white;
                                            font-weight: bold;
                                        }

                                        .fa-choose {
                                            // position: absolute;
                                            // right: 10px;
                                            // top: 115px;
                                            z-index: 101;
                                            color: white;
                                            font-weight: bold;
                                        }
                                        }
                                    }
                                }
                            }
                        }

                        /* 底部按钮 */
                        .btn-group {
                            display: flex;
                            justify-content: flex-end;
                            gap: 15px;
                            padding-top: 10px;

                            .btn {
                                min-width: 100px;
                                height: 38px;
                                line-height: 38px;
                                border-radius: 5px;
                                cursor: pointer;
                                transition: all 0.2s;
                                text-align: center;

                                &.btn-cancel {
                                    color: black;
                                    border: 1px solid #e5e5e5;
                                }

                                &.btn-confirm {
                                    color: white;
                                    background: #fa3d5a;
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    @media (min-width:1280px) and (max-width:1679px){
        .inner-wrap{
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                max-width:400px;
                margin-right:30px;
                height:100% !important;
                .file-list{
                    width:100% !important;
                    .file-item{
                        width:100%;
                        .pa-img{
                            width:150px;
                            height:150px;
                        }
                        .r1{
                            width:140px;
                            .input{
                                width:100%;
                            }
                        }
                       .upload-wrap{
                        width:100%;
                        .btn-upload{
                            width:100%;
                        }
                       }
                    }
                }
            }
            .right{
                width:auto;
                min-width:600px;
                max-width:1000px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .pattern-wrap{
                    height:100% !important;
                    .content{
                        .category-list{
                            min-width:100px;
                        }
                    }
                }
            }
        }
    }

    @media (max-width:1279px){
        .inner-wrap{
            height:100%;
            overflow:visible;
            .left{
                flex-shrink:0;
                width:auto;
                max-width:350px;
                margin-right:30px;
                height:100% !important;
                .file-list{
                    width:100% !important;
                    .file-item{
                        width:100%;
                        .pa-img{
                            width:120px;
                            height:120px;
                        }
                        .r1{
                            width:120px;
                            .input{
                                width:100%;
                            }
                        }
                       .upload-wrap{
                        width:100%;
                        .btn-upload{
                            width:100%;
                        }
                       }
                    }
                }
            }
            .right{
                width:auto;
                min-width:600px;
                max-width:950px;
                max-height:730px;
                flex-shrink:0;
                margin-right:0;
                height:100%;
                .pattern-wrap{
                    height:100% !important;
                    .content{
                        .category-list{
                            min-width:100px;
                        }
                    }
                }
            }
        }
    }

    ::v-deep .ivu-upload{
        width:100%;
    }

    ::v-deep .popup-modal {
        /* 核心容器 */
        position: fixed;
        top: 0;
        left: 0;
        width: 100vw;
        height: 100vh;
        display: flex;
        justify-content: center;
        align-items: center;
        z-index: 999;
        background: rgba(0, 0, 0, 0.6);

        /* 弹窗内容区 */
        .popup-content {
            background: #fff;
            border-radius: 10px;
            //   width: min(980px, 92vw); // 最大980px，最小占92%视口宽
            /* 修正后 */
            width: max(980px, 96vw); // 增加视口占比
            min-width: 320px; // 保障最小可操作宽度
            max-width: none !important; // 移除潜在限制

            /* 添加边距保护 */
            margin: 0 2vw; // 左右留白
            box-sizing: content-box; // 防止padding影响
            max-height: max(720px, 85vh); // 最大720px，最小占85%视口高
            height: 30vh;
            display: flex;
            flex-direction: column;
            overflow: hidden;
        }
    }

    .fabric-content-wrap {
        margin-top: 40px;
        overflow-y: scroll;
        height: 600px;

        .title-box{
            display:flex;
            align-items: center;
            column-gap:13px;
            .title {
                color: #1a1a1a;
                font-size: 16px;
                border-left: none;
                font-weight: bold;
                margin-bottom: 0;
                padding: 10px 0;
                height: auto;
            }
            .line{
                flex:1;
                height:1px;
                background:#ebebeb;
            }
        }

        .info-wrap {
            display: flex;
            justify-content: space-around;

            .left-popup {
                width: 420px;
                border:1px solid #e5e5e5;
                .f-img {
                    width: 420px;
                    height: 420px;
                    object-fit:contain;
                }
            }

            .right {
                width: 500px;
                padding-right:20px;
                padding-left:20px;
                display:flex;
                flex-direction:column;
                align-items:start;
                row-gap:0;
                .name {
                    color: #1a1a1a;
                    font-size: 20px;
                    padding-bottom:18px;
                    border-bottom:1px solid #ebebeb;
                    width:100%;
                }

                .no {
                    color: #808080;
                    font-size: 14px;
                    margin: 25px 0;
                    span{
                        color:#1a1a1a;
                        font-size:14px;
                    }
                }

                .item {
                    margin: 5px 0;

                    .key {
                        display: inline-block;
                        color: #808080;
                        width: 80px;
                    }

                    .value {
                        color: #1a1a1a;
                    }
                }
            }
        }

        .richtext-wrap {
            padding:15px;
            .size-list{
                display:flex;
                align-items:center;
                column-gap:5px;
                margin-bottom:10px;
                span{
                    background:rgb(237,245,254);
                    border:1px solid rgb(230,241,253);
                    color:rgb(143,198,248);
                    border-radius:5px;
                    padding:3px 5px;
                }
            }
            table {
                width: 100%;
                border-collapse: collapse;
                font-size: 14px;
            }

            th,
            td {
                border: 1px solid #ddd;
                padding: 8px;
            }

            th:first-child,
            td:first-child {
                position: sticky;
                left: 0;
                background: white;
                z-index: 1;
                box-shadow: 1px 0 0 #ccc; /* 添加视觉分隔 */
            }
        }

    }
    .btn-box{
            display:flex;
            justify-content:center;
            column-gap:20px;
            position:sticky;
            bottom:0;
            left:0;
            right:0;
            z-index:1;
            background:#ffffff;
            padding:10px 0;
            .cancel-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#ffffff;
                border:1px solid #e5e5e5;
                color:#1a1a1a;
                font-size:14px;
                cursor:pointer;
            }
            .confirm-btn{
                width:120px;
                height:38px;
                border-radius:19px;
                background:#1a1a1a;
                color:#ffffff;
                font-size:14px;
                cursor:pointer;
            }
        }

    .slider {
        width: 420px;
        height: 420px;
        overflow: hidden;

        .swiper-slide {
            width: 420px;
            height: 420px;
        }

        .img {
            width: 420px;
            height: 420px;
            object-fit:contain;
        }
    }

    ::v-deep .ivu-modal-confirm{
        text-align:left !important;
        font-weight:bold !important;
    }
    ::v-deep .ivu-btn-primary{
        background-color:#fa3d5a !important;
    }
</style>
